export default [
    {
        path: '/visitorlog',
        meta: {
            title: "Visitor Log",
            show: true
        },
        component: () => import(/* webpackChunkName: "visitor" */ '../views/admin/page/VisitorLog/Index'),
        redirect: { name: 'visitor.dashboard' },
        children: [
            {
                path: 'dashboard',
                name: 'visitor.dashboard',
                meta: {
                    title: "Visitor Log Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "visitor" */ '../views/admin/page/VisitorLog/VisitorDashboard'),
            },
        ]
    }
]